export const Services = ( ) => {

const data = [
    {
        id: 1,
        title: "FADE CUT",
        price: "35$"
    },

    {
        id: 2,
        title: "SCISSOR CUT ONLY",
        price: "30$"
    },

    {
        id: 3,
        title: "BUZZ CUT",
        price: "20$"
    },

    {
        id: 4,
        title: "BEARD TRIM AND CLEANUP",
        price: "30$"
    },

    {
        id: 5,
        title: "FULL CUT AND BEARD",
        price: "65$"
    },

    {
        id: 6,
        title: "FACE CLEANING",
        price: "25$"
    },
    
    {
        id: 7,
        title: "CHILDREN UNDER 15",
        price: "30$"
    },

    {
        id: 8,
        title: "WAX EARS",
        price: "10$"
    },

    {
        id: 9,
        title: "WAX NOSE",
        price: "10$"
    },

    {
        id: 10,
        title: "WAX CHEEKS",
        price: "10$"
    },

    {
        id: 11,
        title: "SHAMPOO WASH",
        price: "5$"
    },

    {
        id: 12,
        title: "SHAWE",
        price: "35$"
    },

    {
        id: 13,
        title: "LINE ONLY",
        price: "5$"
    },

    {
        id: 14,
        title: "EYEBROW CLEAN UP",
        price: "10$"
    }




    
];

    return (
        <section id="Services" >
            <h2>SERVICES</h2>
            <div className="m-bl-servises">
                {data.map((element, index) => {
                    const {id, title, price} = element;
                    return(
                        <div key={id} className="servies-item">
                            <h5>{title}</h5>
                            <h4><span>{price}</span></h4>
                        </div>
                    ) 
                })}
            </div>
        </section>
    );
}